// MULTI-REGIÃO/MULTI-FILIAIS: variante de topo "multi-filiais" (modelo_topo = 4).
// COMPOSIÇÃO (não cópia) do Topo padrão: renderiza uma barra fina com o seletor
// de região em cima e o <Topo/> normal embaixo. Sem regiões configuradas no
// tenant, degrada EXATAMENTE pro topo padrão (barra some).
//
// V2 (modo popup): a barra deixa de ser uma lista de chips e vira o resumo
// "Filial: <nome> · Trocar", que abre o popup de filiais (a escolha mora lá,
// com endereço e badge de matriz). No mobile ela some — lá quem manda é a pill
// fixa do popup. No modo barra (V1) NADA muda.
import { FaMapMarkerAlt } from 'react-icons/fa';
import { isColorLight } from '../../../utils/FunctionsGlobals';
import { useRegiao } from '../../context/Info';
import Topo from '../topo/Topo';
import styles from './TopoRegioes.module.css';

const TODAS_VALUE = '__todas__';

const TopoRegioes: React.FC<{
    site: any;
    setActiveDrawer: any;
}> = ({ site, setActiveDrawer }) => {
    const { regioes, regiaoAtiva, regiaoMatriz, modoPopup, setRegiao, setFilialPopupAberto } = useRegiao();

    // Tenant sem multi-região (lista vazia/backend ainda sem o campo) → topo padrão puro.
    if (!regioes.length) {
        return <Topo site={site} setActiveDrawer={setActiveDrawer} />;
    }

    const corBarra = site?.cor2 || site?.cor1 || '#1f1f1f';
    const corTexto = isColorLight(corBarra) ? (site?.cor11 || '#1a1a1a') : (site?.cor13 || '#ffffff');

    const onSelect = (slug: string) => {
        setRegiao(slug === TODAS_VALUE ? null : slug);
    };

    if (modoPopup) {
        const nomeAtivo = regiaoAtiva?.nome || regiaoMatriz?.nome || '';
        return (
            <>
                <div
                    className={`${styles.bar} ${styles.barFilial}`}
                    style={{ background: corBarra, color: corTexto }}
                >
                    <span className={styles.label}>
                        <FaMapMarkerAlt aria-hidden="true" />
                        Filial:
                    </span>
                    <strong className={styles.filialNome}>{nomeAtivo}</strong>
                    <button
                        type="button"
                        className={styles.trocar}
                        aria-haspopup="dialog"
                        onClick={() => setFilialPopupAberto(true)}
                    >
                        Trocar
                    </button>
                </div>
                <Topo site={site} setActiveDrawer={setActiveDrawer} />
            </>
        );
    }

    return (
        <>
            <div
                className={styles.bar}
                style={{ background: corBarra, color: corTexto }}
                role="navigation"
                aria-label="Selecionar região de atendimento"
            >
                <span className={styles.label}>
                    <FaMapMarkerAlt aria-hidden="true" />
                    Região:
                </span>

                {/* desktop: chips */}
                <div className={styles.chips}>
                    <button
                        type="button"
                        className={`${styles.chip} ${!regiaoAtiva ? styles.chipAtivo : ''}`}
                        aria-pressed={!regiaoAtiva}
                        onClick={() => onSelect(TODAS_VALUE)}
                    >
                        Todas as regiões
                    </button>
                    {regioes.map((regiao) => (
                        <button
                            key={regiao.slug}
                            type="button"
                            className={`${styles.chip} ${regiaoAtiva?.slug === regiao.slug ? styles.chipAtivo : ''}`}
                            aria-pressed={regiaoAtiva?.slug === regiao.slug}
                            onClick={() => onSelect(regiao.slug)}
                        >
                            {regiao.nome}
                        </button>
                    ))}
                </div>

                {/* mobile: dropdown compacto */}
                <select
                    className={styles.select}
                    aria-label="Selecionar região"
                    value={regiaoAtiva?.slug || TODAS_VALUE}
                    onChange={(e) => onSelect(e.target.value)}
                >
                    <option value={TODAS_VALUE}>Todas as regiões</option>
                    {regioes.map((regiao) => (
                        <option key={regiao.slug} value={regiao.slug}>
                            {regiao.nome}
                        </option>
                    ))}
                </select>
            </div>
            <Topo site={site} setActiveDrawer={setActiveDrawer} />
        </>
    );
};

export default TopoRegioes;
